<template>
    <div>
        <v-text-field
            autofocus
            v-model="model"
            :label="label"
            append-icon="mdi-magnify"
            outlined
            dense
            hide-details="auto"
            @keyup.enter="emitSearch"
            @click:append="emitSearch"
        />
        <div v-if="!disableExamples" class="mt-2 d-flex align-center flex-wrap" style="gap: 8px;">
            <v-chip
                v-for="example in examples"
                small
                outlined
                @click="applyExample(example, true)"
                :key="example"
            >
                {{ example }}
            </v-chip>
        </div>
    </div>
</template>

<script>
export default {
    name: "PixabaySearchInput",
    props: {
        value: {type: String, default: ""},
        disableExamples: {type: Boolean, default: false}
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
        label() {
            return Lang.langGet("Search images");
        },
        examples() {
            return ['digital+signage', 'digital signage', 'digital', 'background', 'nature'];
        }
    },
    methods: {
        emitSearch() {
            this.$emit("search");
        },
        applyExample(example, autoSearch = false) {
            this.model = example;
            if (autoSearch) this.emitSearch();
        },
    },
};
</script>
